<template>
  <v-container class="custom-container">
    <v-row dense>
      <v-col cols="12">
        <v-card
          class="pa-5 live-trade-details-card"
          elevation="0"
          :color="$vuetify.theme.dark ? '#131c29' : '#E0EAF2'"
        >
          <v-row class="no-gutters align-center">
            <v-col cols="12">
              <v-text-field
                v-model="search"
                prepend-icon="mdi-magnify"
                label="Search here..."
                single-line
                solo
                hide-details
                class="mt-0 mr-0"
              ></v-text-field>
            </v-col>
          </v-row>
          <v-row dense>
            <v-col cols="12" sm="12">
              <v-card
                class="pa-0 rounded-0 elevation-0"
                :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
              >
                <v-sheet
                  class="transactionTable depositTabTable"
                  :color="$vuetify.theme.dark ? '#162334 ' : '#E8F1F8'"
                >
                  <v-data-table
                    :headers="headers"
                    :items="Transaction"
                    :items-per-page="5"
                  >
                    <template v-slot:item.nameLink="{ item }">
                      <router-link
                        class="text-capitalize text--ash"
                        :to="item.nameLinkName"
                      >
                        {{ item.nameLink }}
                      </router-link>
                    </template>
                    <template v-slot:item.accNo="{ item }">
                      <router-link
                        class="text-capitalize text--ash"
                        :to="item.accNameLink"
                      >
                        {{ item.accName }}
                      </router-link>
                    </template>
                    <template v-slot:item.status="{ item }">
                      <div class="d-flex">
                        <v-icon small :class="verifyIcon(item.status)"></v-icon>
                        {{ item.status }}
                      </div>
                    </template>
                  </v-data-table>
                </v-sheet>
              </v-card>
            </v-col>
          </v-row>
        </v-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
export default {
  data() {
    return {
      search: "",
      modal: false,
      dialog: false,
      date: ["2022-01-01", "2023-01-01"],
      slots1: ["7100001492(MICRO)", "7100006392(MICRO)", "7102006392(MICRO)"],
      headers: [
        { text: "Date and Time", align: "start", value: "dateAndTime" },
        { text: "Name", value: "nameLink" },
        { text: "Email", value: "email" },
        { text: "Acc.No.", value: "accNo" },
        { text: "Password", value: "password" },
        { text: "Investor Pass.", value: "invPassword" },
        { text: "Leverage", value: "leverage" },
        { text: "Deposit", value: "deposit" },
      ],
      Transaction: [
        {
          dateAndTime: "25.08.20-08:32 am",
          nameLink: "Abu Bokor",
          nameLinkName: "/abu-bokor",
          email: "abuBokor@gmail.com",
          accName: "5004",
          accNameLink: "/5004",
          password: "pvKVYCEq",
          invPassword: "pvKVYCEq",
          leverage: "10",
          deposit: "$100",
        },
        {
          dateAndTime: "28.05.10-08:12 pm",
          nameLink: "Osman",
          nameLinkName: "/osman",
          email: "osman@gmail.com",
          accName: "992",
          accNameLink: "/992",
          password: "Adjeuwi",
          invPassword: "Adjeuwi",
          leverage: "17",
          deposit: "$120",
        },
      ],
    };
  },
  computed: {
    dateRangeText() {
      return this.date.join(" ~ ");
    },
  },
};
</script>
